import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Schema, getTourlaneMetaContext, PageType, Action, EVENT_TYPE, filterFalsy, withAsyncGlobalContext, trackSelfDescribingEvent } from './snowplow';
export var LandingPageStep; // This fn  uses null-coalescing op to set undefined/null to empty string for data sent to Snowplow

(function (LandingPageStep) {
  LandingPageStep["EMAIL"] = "email";
  LandingPageStep["PHONE"] = "phone";
  LandingPageStep["PHONE_NUMBER"] = "phone_number";
  LandingPageStep["ZIP_CODE"] = "zip_code";
})(LandingPageStep || (LandingPageStep = {}));

var defaultToEmptyStringIfNotPassed = function defaultToEmptyStringIfNotPassed(args) {
  var keys = Object.keys(args);
  return keys.reduce(function (acc, curr) {
    var _objectSpread2;

    return _objectSpread((_objectSpread2 = {}, _objectSpread2[curr] = args[curr] === null || typeof args[curr] === 'undefined' ? '' : args[curr], _objectSpread2), acc);
  }, {});
};

export var getLandingPageEntity = function getLandingPageEntity(id) {
  return {
    schema: Schema.LANDING_PAGE_ENTITY,
    data: {
      id: String(id)
    }
  };
};
export var getTravelRequestEntity = function getTravelRequestEntity(uuid) {
  return {
    schema: Schema.TRAVEL_REQUEST_ENTITY,
    data: {
      travel_request_uuid: uuid
    }
  };
};
export var getComponentEntity = function getComponentEntity(componentName, componentUniqueIdentifier) {
  return {
    schema: Schema.COMPONENT_ENTITY,
    data: {
      component: componentName,
      id: componentUniqueIdentifier
    }
  };
};
export var DiscountType;

(function (DiscountType) {
  DiscountType["AMOUNT"] = "amount";
  DiscountType["PERCENT"] = "percent";
  DiscountType["UNIT"] = "unit";
})(DiscountType || (DiscountType = {}));

export var getVoucherEntity = function getVoucherEntity(_ref) {
  var code = _ref.code,
      discountType = _ref.discountType,
      discount = _ref.discount,
      currency = _ref.currency,
      name = _ref.name;
  return {
    schema: Schema.VOUCHER_ENTITY,
    data: {
      code: code,
      discount_type: discountType,
      discount: discount,
      currency: currency,
      name: name
    }
  };
};
// we use defaultToEmptyStringIfNotPassed since answers are deeply nested prop, so defaultToEmptyStringIfNotPassed is not called on them in consumer of this fn.
export var getQualificationAnswerEntity = function getQualificationAnswerEntity(args) {
  var newArgs = defaultToEmptyStringIfNotPassed(args);
  return {
    schema: Schema.QUALIFICATION_ANSWER_ENTITY,
    data: _objectSpread({}, newArgs)
  };
};
export var trackTravelRequestEvent = withAsyncGlobalContext(function (uuid) {
  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: Schema.ID_MAP_EVENT,
      data: {}
    },
    context: [getTravelRequestEntity(uuid)]
  });
});
/**
 * Sends either CLICK_EVENT or HOVER_EVENT based on what's passed as eventType.
 * Entites sent by this event:
 *  - tourlane_meta_entity
 *  - component
 */

export var trackClickOrHoverEvent = withAsyncGlobalContext(function (args) {
  var _defaultToEmptyString = defaultToEmptyStringIfNotPassed(args),
      eventType = _defaultToEmptyString.eventType,
      destinationUUID = _defaultToEmptyString.destinationUUID,
      pageType = _defaultToEmptyString.pageType,
      componentName = _defaultToEmptyString.componentName,
      componentUniqueIdentifier = _defaultToEmptyString.componentUniqueIdentifier;

  var schema = eventType === Action.CLICK ? Schema.CLICK_EVENT : Schema.HOVER_EVENT;
  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: schema,
      data: {}
    },
    context: [getTourlaneMetaContext(pageType, destinationUUID), getComponentEntity(componentName, componentUniqueIdentifier)]
  });
});
export var trackQualificationSignupEvent = withAsyncGlobalContext(function (args) {
  var _defaultToEmptyString2 = defaultToEmptyStringIfNotPassed(args),
      type = _defaultToEmptyString2.type,
      stepName = _defaultToEmptyString2.stepName,
      stepNumber = _defaultToEmptyString2.stepNumber,
      destination = _defaultToEmptyString2.destination,
      id = _defaultToEmptyString2.id;

  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: Schema.QUALIFICATION_SIGNUP_EVENT,
      data: {
        type: type,
        step_name: stepName,
        step_num: stepNumber
      }
    },
    context: filterFalsy([getTourlaneMetaContext(PageType.LANDING_PAGE, destination), getLandingPageEntity(id)])
  });
});
export var trackQualificationQuestionnaireCompleteEvent = withAsyncGlobalContext(function (args) {
  var _defaultToEmptyString3 = defaultToEmptyStringIfNotPassed(args),
      destination = _defaultToEmptyString3.destination,
      id = _defaultToEmptyString3.id,
      length = _defaultToEmptyString3.length;

  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: Schema.QUALIFICATION_QUESTIONNAIRE_COMPLETE_EVENT,
      data: {
        length: length
      }
    },
    context: [getTourlaneMetaContext(PageType.LANDING_PAGE, destination), getLandingPageEntity(id)]
  });
});
export var trackQualificationQuestionnaireFlowEvent = withAsyncGlobalContext(function (args) {
  var _defaultToEmptyString4 = defaultToEmptyStringIfNotPassed(args),
      type = _defaultToEmptyString4.type,
      currentIndex = _defaultToEmptyString4.currentIndex,
      maxIndex = _defaultToEmptyString4.maxIndex,
      question = _defaultToEmptyString4.question,
      answers = _defaultToEmptyString4.answers,
      destination = _defaultToEmptyString4.destination,
      id = _defaultToEmptyString4.id;

  var qualificationAnswersEntities = answers.map(function (answer) {
    return getQualificationAnswerEntity(answer);
  });
  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: Schema.QUALIFICATION_QUESTIONNAIRE_FLOW_EVENT,
      data: {
        type: type,
        current_idx: currentIndex,
        max_idx: maxIndex,
        question: question
      }
    },
    context: [].concat(qualificationAnswersEntities, [getTourlaneMetaContext(PageType.LANDING_PAGE, destination), getLandingPageEntity(id)])
  });
});
export var trackValidateVoucherEvent = withAsyncGlobalContext(function (args) {
  var _defaultToEmptyString5 = defaultToEmptyStringIfNotPassed(args),
      success = _defaultToEmptyString5.success,
      label = _defaultToEmptyString5.label,
      destination = _defaultToEmptyString5.destination,
      id = _defaultToEmptyString5.id,
      code = _defaultToEmptyString5.code,
      discount = _defaultToEmptyString5.discount,
      discountType = _defaultToEmptyString5.discountType,
      currency = _defaultToEmptyString5.currency,
      name = _defaultToEmptyString5.name;

  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: Schema.VOUCHER_VALIDATE_EVENT,
      data: {
        success: success,
        label: label
      }
    },
    context: [getTourlaneMetaContext(PageType.LANDING_PAGE, destination), getLandingPageEntity(id), getVoucherEntity({
      code: code,
      discount: discount,
      discountType: discountType,
      currency: currency,
      name: name
    })]
  });
});

var getConversionEvent = function getConversionEvent(conversionStep) {
  return {
    schema: Schema.CONVERSION_EVENT,
    data: {
      step: conversionStep
    }
  };
};

export var trackConversionSnowplowStep = function trackConversionSnowplowStep(_ref2) {
  var conversionStep = _ref2.conversionStep,
      travelRequestUuid = _ref2.travelRequestUuid,
      pageType = _ref2.pageType,
      destinationUuid = _ref2.destinationUuid;
  trackSelfDescribingEvent({
    pageType: pageType,
    destination: destinationUuid,
    event: getConversionEvent(conversionStep),
    entities: [getTravelRequestEntity(travelRequestUuid)]
  });
};